import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'impersonatedClientEmployee';

/**
 * The client employee a Royal Crown employee is logged in as.
 * Kept in localStorage so it survives reloads and new tabs; logging out clears localStorage.
 */
@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  readonly clientEmployeeId = signal<string | null>(readStoredId());

  start(clientEmployeeId: string | number): void {
    const id = String(clientEmployeeId);
    try {
      localStorage.setItem(STORAGE_KEY, id);
    } catch {
      // storage unavailable: impersonation then only lasts until the page reloads
    }
    this.clientEmployeeId.set(id);
  }

  stop(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // nothing stored
    }
    this.clientEmployeeId.set(null);
  }
}

function readStoredId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
